module.exports = "<div class=\"_automations-view\">\n\n  <cm-table-users></cm-table-users>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/usersView/usersView.vue
// module id = 386
// module chunks = 0